import { render, staticRenderFns } from "./DocumentsIndexComponent.vue?vue&type=template&id=7068697e"
import script from "./DocumentsIndexComponent.vue?vue&type=script&lang=js"
export * from "./DocumentsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports